"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhiteSolidArrow = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme");
const WhiteSolidArrow = props => (react_1.default.createElement("svg", Object.assign({ width: "16", height: "7", viewBox: "0 0 16 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { d: "M15.7002 7L9.14094 0.383564C8.63396 -0.127855 7.36647 -0.127855 6.85945 0.383564L0.300196 7L15.7002 7Z", fill: Theme_1.theme.palette.BW_100 })));
exports.WhiteSolidArrow = WhiteSolidArrow;
